const AGE_COOKIE = 'cannalicious_age_verified';

function setCookie( name, value, days ) {
	const maxAge = days * 24 * 60 * 60;
	document.cookie = `${ name }=${ value }; max-age=${ maxAge }; path=/; SameSite=Lax`;
}

function initAgeGate() {
	const gate = document.getElementById( 'cannalicious-age-gate' );
	if ( ! gate ) {
		return;
	}

	document.documentElement.style.overflow = 'hidden';
	document.body.classList.add( 'is-age-gated' );

	const confirmBtn = gate.querySelector( '[data-age-gate-confirm]' );
	const declineBtn = gate.querySelector( '[data-age-gate-decline]' );

	confirmBtn?.addEventListener( 'click', () => {
		setCookie( AGE_COOKIE, '1', 30 );
		gate.remove();
		document.documentElement.style.overflow = '';
		document.body.classList.remove( 'is-age-gated' );
	} );

	declineBtn?.addEventListener( 'click', () => {
		window.location.href = 'https://www.google.com';
	} );

	confirmBtn?.focus();
}

function initNavToggle() {
	const toggle = document.querySelector( '.nav-toggle' );
	const nav = document.querySelector( '.cannalicious-nav' );
	if ( ! toggle || ! nav ) {
		return;
	}

	toggle.addEventListener( 'click', () => {
		const isOpen = nav.classList.toggle( 'is-open' );
		toggle.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
	} );
}

function initNewsletterForms() {
	document.querySelectorAll( '.newsletter__form' ).forEach( ( form ) => {
		form.addEventListener( 'submit', async ( e ) => {
			e.preventDefault();
			const input = form.querySelector( 'input[type="email"]' );
			const messageEl = form.parentElement.querySelector( '.newsletter__message' );
			const email = input?.value?.trim();

			if ( ! email ) {
				return;
			}

			try {
				const res = await fetch( window.cannaliciousData.restUrl + 'newsletter/subscribe', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-WP-Nonce': window.cannaliciousData.nonce,
					},
					body: JSON.stringify( { email } ),
				} );
				const data = await res.json();

				if ( messageEl ) {
					messageEl.textContent = data.success
						? 'Thanks for subscribing!'
						: ( data.message || 'Something went wrong. Please try again.' );
					messageEl.classList.toggle( 'is-success', !! data.success );
					messageEl.classList.toggle( 'is-error', ! data.success );
				}

				if ( data.success ) {
					form.reset();
				}
			} catch ( err ) {
				if ( messageEl ) {
					messageEl.textContent = 'Something went wrong. Please try again.';
					messageEl.classList.add( 'is-error' );
				}
			}
		} );
	} );
}

function initContactForm() {
	const form = document.querySelector( '[data-contact-form]' );
	if ( ! form ) {
		return;
	}

	form.addEventListener( 'submit', async ( e ) => {
		e.preventDefault();
		const messageEl = form.querySelector( '.contact-form__message' );
		const submitBtn = form.querySelector( 'button[type="submit"]' );
		const payload = {
			name: form.querySelector( '#contact-name' )?.value?.trim(),
			email: form.querySelector( '#contact-email' )?.value?.trim(),
			message: form.querySelector( '#contact-message' )?.value?.trim(),
			website: form.querySelector( '#contact-website' )?.value || '',
		};

		if ( ! payload.name || ! payload.email || ! payload.message ) {
			return;
		}

		submitBtn.disabled = true;

		try {
			const res = await fetch( window.cannaliciousData.restUrl + 'contact', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-WP-Nonce': window.cannaliciousData.nonce,
				},
				body: JSON.stringify( payload ),
			} );
			const data = await res.json();

			if ( messageEl ) {
				messageEl.textContent = data.success
					? 'Thanks! We’ll be in touch soon.'
					: ( data.message || 'Something went wrong. Please try again.' );
				messageEl.classList.toggle( 'is-success', !! data.success );
				messageEl.classList.toggle( 'is-error', ! data.success );
			}

			if ( data.success ) {
				form.reset();
			}
		} catch ( err ) {
			if ( messageEl ) {
				messageEl.textContent = 'Something went wrong. Please try again.';
				messageEl.classList.add( 'is-error' );
			}
		} finally {
			submitBtn.disabled = false;
		}
	} );
}

/**
 * Generic +/- stepper behavior, shared by every WooCommerce quantity input
 * on the site (single-product Shopping Summary, cart page) since they all
 * share the woocommerce/global/quantity-input.php override.
 */
function initQtySteppers() {
	document.querySelectorAll( '.qty-stepper' ).forEach( ( stepper ) => {
		const input = stepper.querySelector( 'input.qty-stepper__input' );
		const minus = stepper.querySelector( '.qty-stepper__btn--minus' );
		const plus = stepper.querySelector( '.qty-stepper__btn--plus' );
		if ( ! input ) {
			return;
		}

		const step = parseFloat( input.step ) || 1;

		const setValue = ( next ) => {
			const min = input.min !== '' ? parseFloat( input.min ) : 0;
			const max = input.max !== '' ? parseFloat( input.max ) : Infinity;
			input.value = Math.min( max, Math.max( min, next ) );
			input.dispatchEvent( new Event( 'change', { bubbles: true } ) );
		};

		minus?.addEventListener( 'click', () => setValue( ( parseFloat( input.value ) || 0 ) - step ) );
		plus?.addEventListener( 'click', () => setValue( ( parseFloat( input.value ) || 0 ) + step ) );
	} );
}

document.addEventListener( 'DOMContentLoaded', () => {
	initAgeGate();
	initNavToggle();
	initNewsletterForms();
	initContactForm();
	initQtySteppers();
} );
